import React, { createContext, useContext, useEffect, useState } from 'react'
import { useAuth } from './auth.jsx'
import { getMe } from './api.js'
import { PageContainer } from '@ui'
import { reconcileAppearance } from '@theme'
import { LoginPage } from './pages/LoginPage.jsx'

const MeContext = createContext(null)

export function useMe() {
  return useContext(MeContext)
}

export function AdminPortalGate({ children }) {
  const { user, loading } = useAuth()
  const [me, setMe] = useState(null)
  const [checking, setChecking] = useState(true)

  useEffect(() => {
    if (!user) { setChecking(false); return }
    getMe()
      .then((m) => {
        setMe(m)
        if (m?.appearance) reconcileAppearance(m.appearance)
      })
      .catch(() => setMe(null))
      .finally(() => setChecking(false))
  }, [user])

  if (loading || checking) return <PageContainer><p>Loading…</p></PageContainer>
  if (!user) return <LoginPage />
  if (!me?.isSuperAdmin && !me?.isAdmin) {
    return (
      <PageContainer>
        <h1>Access denied</h1>
        <p>Your account is not authorised for the admin portal.</p>
      </PageContainer>
    )
  }
  return <MeContext.Provider value={me}>{children}</MeContext.Provider>
}
